import { IPreloadedState } from 'shared/types/redux';

export const selectDirectionsModalData = (state: IPreloadedState) => state.geo.directionsModal.data;
